import { useEffect, useMemo, useRef, useState } from "react";
import styled from "styled-components";
import { useEndpointFields } from "../../../utils/hooks/useEndpointFields";
import useApiSteps from "../../../utils/hooks/useApiSteps";
import { useOutletContext, useParams } from "react-router";
import { useSelector } from "react-redux";
import FormField from "../../common/forms/FormField";
import FullScreenLoader from "../../common/loaders/FullScreenLoader";
import FullScreenOverlay from "../../common/overlay/FullScreenOverlay";
import DialogBoxComponent from "../../common/dialogs/DialogBoxComponent";
import { apiActions, authTypeEnums } from "./apiPageHelper";
import ApiPageSidePanel from "../apiPage/apiPageComponents/ApiPageSidePanel";
import AuthorizationPopup from "./apiPageComponents/AuthorizationPopup";
import ConnectedFieldPopup from "./apiPageComponents/ConnectedFieldPopup";
import FormCard from "../../common/forms/FormCard";
import FormContainer from "../../common/forms/FormContainer";
import StepForm from "../apiPage/apiPageComponents/StepForm";
import SimpleButtonContentHeader from "../../common/mainApp/mainWindowHeaders/SimpleButtonContentHeader";
import Plus from "../../../assets/icons/plus.svg";
import * as Library from "../../../utils/Library";
import TestConnectionPopup from "./apiPageComponents/TestConnectionPopup";
import Loader from "../../../assets/images/loader.png";

// #region SCOPED CSS
export const StepFormStyle = styled.div`
    .input-field-card-layout-1,
    .input-field-card-layout-1 * {
        box-sizing: border-box;
    }
    .input-field-card-layout-1 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 16px 0px 32px 0px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-192 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-186 {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .steps {
        color: #ffffff;
        text-align: left;
        font-family: var(--overline-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }
    .statuses {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex: 1;
        position: relative;
    }
    .frame-188 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1882 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .rectangle-7 {
        background: var(--text-and-icons-blue-500, #00aeef);
        border-radius: 600px;
        flex-shrink: 0;
        width: 6px;
        height: 6px;
        position: relative;
    }
    .recommended {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-3-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-3-font-size, 10px);
        font-weight: var(--subtitle-3-font-weight, 400);
        position: relative;
    }
    .frame-1862 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .rectangle-72 {
        background: var(--text-and-icons-orange-500, #ff9900);
        border-radius: 600px;
        flex-shrink: 0;
        width: 6px;
        height: 6px;
        position: relative;
    }
    .mandatory {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-3-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-3-font-size, 10px);
        font-weight: var(--subtitle-3-font-weight, 400);
        position: relative;
    }
    .frame-187 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .rectangle-73 {
        background: var(--text-and-icons-gray-300, #4f5b6d);
        border-radius: 600px;
        flex-shrink: 0;
        width: 6px;
        height: 6px;
        position: relative;
    }
    .locked {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-3-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-3-font-size, 10px);
        font-weight: var(--subtitle-3-font-weight, 400);
        position: relative;
    }
    .line-3 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-276 {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295 {
        display: flex;
        flex-direction: row;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .store-delivery-option-card {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px;
        padding: 8px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        width: 100%;
    }
    .frame-1000011391 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011229 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011443 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-161 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-296 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .step-1 {
        color: #ffffff;
        text-align: left;
        font-family: var(--overline-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }
    .info-circle {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .frame-1000011228 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011227 {
        display: grid;
        grid-template-columns: repeat(2, 0.2fr);
        gap: 16px;
        width: 100%;
    }
    .frame-295922378 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-291 {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-171 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-144 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-158 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .frame-1588 {
        width: 100%;
    }
    .frame-901 {
        display: grid;
        gap: 16px;
        width: 100%;
        grid-template-columns: repeat(3, 0.2fr);
    }
    .frame-902 {
        display: grid;
        gap: 16px;
        width: 100%;
        grid-template-columns: repeat(4, 0.2fr);
    }

    .frame-189 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .dropdown-selector {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 389px;
        position: relative;
    }
    .frame-49 {
        padding: 0px 5px 0px 5px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .info-circle2 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .title {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .input-selector-inverted {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 38px;
        position: relative;
    }
    .frame-492 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px 0px 0px 4px;
        padding: 6px 0px 6px 0px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 5px;
        height: 37px;
        position: relative;
        overflow: hidden;
    }
    .search {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 38px;
        position: relative;
    }
    .frame-48 {
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 0px 4px 4px 0px;
        padding: 6px 12px 6px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 37px;
        position: relative;
    }
    .default-selection {
        color: var(--text-and-icons-green-500, #00bb00);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .chevron-down {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-50 {
        padding: 0px 5px 0px 5px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .simple {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-51 {
        padding: 0px 5px 0px 5px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .info-circle3 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .search2 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        height: 38px;
        position: relative;
    }
    .frame-482 {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 0px 4px 4px 0px;
        padding: 6px 12px 6px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 37px;
        position: relative;
    }
    .placeholder {
        color: var(--text-and-icons-gray-300, #4f5b6d);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        flex: 1;
    }
    .frame-274 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922381 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        max-width: 389px;
    }
    .dropdown-selector2 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        max-width: 389px;
    }
    .info-circle4 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-2959223812 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        width: 40px;
        position: relative;
    }
    .frame-493 {
        opacity: 0;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .info-circle5 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .auth {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .frame-29 {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 37px;
        position: relative;
        margin-top: 8px;
        cursor: pointer;
    }
    .frame-210 {
        background: var(--buttons-all-platforms-gray-500, #10141b);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 37px;
        position: relative;
        margin-top: 8px;
        cursor: not-allowed;
    }
    .eye {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle6 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down3 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .dropdown-selector3 {
        opacity: 0;
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .info-circle7 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down4 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle8 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down5 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .line-4 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-1000011390 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-100001139010 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        background: #1a222d;
        padding: 8px;
        border: 1px solid #3c485a;
        border-radius: 4px;
        margin-bottom: 20px;
    }
    .frame-1000011384 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011382 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922385 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-295922380 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .header-fields {
        color: #ffffff;
        text-align: left;
        font-family: var(--overline-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }
    .info-circle9 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .frame-2959223813 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-271 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .info-circle10 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down6 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle11 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .info-circle12 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down7 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle13 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down8 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-1000011386 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-top: 8px;
    }
    .btn-sm-special {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--buttons-all-platforms-gray-200, #4f5b6d);
        border-width: 1px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 80px;
        height: 25px;
        position: relative;
        cursor: pointer;
    }
    .plus {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .line-7 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-1000011385 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .params-fields {
        color: #ffffff;
        text-align: left;
        font-family: var(--overline-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }
    .info-circle14 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .info-circle15 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down9 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle16 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .info-circle17 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down10 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle18 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down11 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .plus2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .line-5 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-10000113862 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .body-fields {
        color: #ffffff;
        text-align: left;
        font-family: var(--overline-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }
    .info-circle19 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .info-circle20 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down12 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle21 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .info-circle22 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down13 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle23 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down14 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .plus3 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .line-6 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-1000011387 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .return-fields {
        color: #ffffff;
        text-align: left;
        font-family: var(--overline-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
        position: relative;
    }
    .info-circle24 {
        flex-shrink: 0;
        width: 12px;
        height: 12px;
        position: relative;
        overflow: visible;
    }
    .info-circle25 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down15 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle26 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .info-circle27 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down16 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .info-circle28 {
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: relative;
        overflow: visible;
    }
    .chevron-down17 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .plus4 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .frame-295922379 {
        padding: 0px 16px 0px 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-end;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .btn-sm-special2 {
        background: var(--buttons-all-platforms-gray-300, #1e2631);
        border-radius: 4px;
        border-style: solid;
        border-color: var(--buttons-all-platforms-gray-200, #4f5b6d);
        border-width: 1px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 25px;
        position: relative;
    }
    .plus5 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .step {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--button-text-large-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--button-text-large-font-size, 12px);
        letter-spacing: var(--button-text-large-letter-spacing, 0.0125em);
        font-weight: var(--button-text-large-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }
    .checkbox-label {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        position: relative;
    }
    .text {
        color: var(--text-and-icons-blue-500, #00aeef);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        cursor: pointer;
    }
    .frame-1000011459,
    .frame-1000011459 * {
        box-sizing: border-box;
    }
    .frame-1000011459 {
        padding: 0px 0px 24px 0px;
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011396 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .mandatory {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .frame-1000011397 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        overflow: hidden;
    }
    .checkbox-label {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .check-circle {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .gtin {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .check-circle2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .mandatory-2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .check-circle3 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .mandatory-3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .check-circle4 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .mandatory-4 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .thumbs-up {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .you-re-good-to-go {
        color: var(--text-and-icons-green-500, #00bb00);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }

    .frame-1000011398 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .recommended {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .check-circle5 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .recommended-1 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .check-circle6 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .recommended-2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .check-circle7 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .recommended-3 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .checkbox {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
    }
    .rectangle-1 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 8px;
        border-style: solid;
        border-color: var(--text-and-icons-gray-300, #4f5b6d);
        border-width: 1px;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .x-close {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .recommended-4 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .x-close2 {
        width: 62.5%;
        height: 62.5%;
        position: absolute;
        right: 18.75%;
        left: 18.75%;
        bottom: 18.75%;
        top: 18.75%;
        overflow: visible;
    }
    .recommended-5 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-1-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-1-font-size, 14px);
        letter-spacing: var(--subtitle-1-letter-spacing, 0.0025em);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
    }
    .input-width {
        width: 210px;
    }
`;
// #endregion

const ApiPage = () => {
    // #region URL params
    const { action } = useParams();
    const searchParams = new URLSearchParams(window.location.search);
    const apiName = searchParams.get("apiName");
    const posID = searchParams.get("posID");
    const posName = searchParams.get("posName");
    const environmentName = searchParams.get("environmentName");
    // #endregion

    // #region STATES
    const [authOptions, setAuthOptions] = useState(["+ Create New"]);
    const [connectedFieldOptions, setConnectedFieldOptions] = useState([]);
    const [showAuthModal, setShowAuthModal] = useState(false);
    const [authDetails, setAuthDetails] = useState({
        type: "",
        name: "",
        token: ""
    });

    const [apiStepsData, setApiStepsData] = useState([]);
    const [connectedFieldDetails, setConnectedFieldDetails] = useState({
        name: "",
        type: "",
        predefinedValue: ""
    });

    const [showConnectedFieldModal, setShowConnectedFieldModal] = useState(false);
    const [showApiPageSidePanel, setShowApiPageSidePanel] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState({
        category: "",
        fields: {}
    });
    const [loading, setLoading] = useState(false);
    const [authLoader, setAuthLoader] = useState(false);
    const [connectedFieldLoader, setConnectedFieldLoader] = useState(false);
    const [testConnectionLoader, setTestConnectionLoader] = useState(false);

    const [showSaveApiModal, setShowSaveApiModal] = useState(false);
    const [isAuthFormValid, setIsAuthFormValid] = useState(false);
    const [showTestConnection, setShowTestConnection] = useState({
        showButton: false,
        showPopup: false,
        isSuccess: undefined
    });

    const [posFields] = useState([{ name: posName, value: posID }]);
    const [environmentNames] = useState([{ name: environmentName, value: environmentName }]);
    const [apiNames] = useState([{ name: apiName, value: apiName }]);
    const [authorizationFieldsData, setAuthorizationFieldsData] = useState({
        authName: "",
        authData: []
    });
    const [testApiData, setTestApiData] = useState([]);
    // #endregion

    // #region  computed vars
    const endpointOptions = useEndpointFields(apiName);
    const {
        steps,
        addStep,
        addField,
        updateField,
        getFieldsByCategory,
        removeField,
        removeStep,
        updateStepField,
        getFilteredSteps,
        getEndpointFields,
        useFormValidation,
        useEndpointDataValidation,
        extractFields,
        testFormValidation,
        resetStepsFieldValues,
        mergeStepsWithAuthData,
        popupDropDown,
        stepsWithAuth,
        updatePopField,
        updateArraySubField,
        removeArraySubField
    } = useApiSteps({
        connectedFieldOptions,
        endpointOptions,
        apiStepsData
    });
    const { MainLayoutProps, layoutType } = useOutletContext();
    const navigations = useSelector(state => state.navigationAccesses);
    const isFormValid = useFormValidation(steps);
    const { validate } = useEndpointDataValidation();

    useMemo(() => {
        return mergeStepsWithAuthData({
            steps,
            authorizationFieldsData: authorizationFieldsData?.authData,
            connectedFieldOptions
        });
    }, [steps, authorizationFieldsData, connectedFieldOptions]);
    const { connectFields, extraFields } = extractFields(stepsWithAuth);
    const isTestFormValid = testFormValidation(steps);
    // #endregion

    // #region METHODS

    const { inputFields = [], outputFields = [] } = getEndpointFields(apiName);
    const filteredSteps = getFilteredSteps({ steps });
    const props = {
        layoutType,
        setControlBarLeftBtns: MainLayoutProps?.setControlBarLeftBtns,
        setControlBarCenterBtns: MainLayoutProps?.setControlBarCenterBtns,
        setControlBarRightBtns: MainLayoutProps?.setControlBarRightBtns,
        setFilterHeaderProperties: MainLayoutProps?.setFilterHeaderProperties,
        setRefreshUserData: MainLayoutProps?.setRefreshUserData,
        navigations,
        steps,
        isFormValid,
        onSaveButtonClick: () => {
            setShowSaveApiModal(true);
        },
        secondBtnEnabled: showTestConnection.showButton,
        onSecondBtnClick: () => {
            setShowTestConnection(prev => ({
                ...prev,
                showPopup: true
            }));
        },
        action
    };

    const formProductIDs = useRef();
    const formFieldRefs = [];

    const productFormFields = [
        <FormField
            type="dropdown"
            title="To POS"
            tooltip="To POS"
            dropdownData={posFields}
            requiredType="locked"
            assistiveText=""
            varName="selectedToPOS"
            ref={el => (formFieldRefs.selectedToPOS = el)}
            value={posName}
        />,
        <FormField
            type="dropdown"
            title="Environment"
            tooltip="Environment"
            dropdownData={environmentNames}
            requiredType="locked"
            assistiveText=""
            varName="selectedEnvironments"
            ref={el => (formFieldRefs.selectedEnvironments = el)}
            value={environmentName}
        />,
        <FormField
            type="dropdown"
            title="API name"
            tooltip="API name"
            dropdownData={apiNames}
            requiredType="locked"
            assistiveText=""
            varName="selectedApiName"
            ref={el => (formFieldRefs.selectedApiName = el)}
            value={apiName}
        />
    ];
    const handleAuthChange = (key, value, dynamicKey = "", includeDynamic = false) => {
        setAuthDetails(prev => ({
            ...prev,
            [key]: value,
            ...(includeDynamic && dynamicKey ? { [dynamicKey]: value } : {})
        }));
    };

    const handleConnectedFieldChange = (key, value) => {
        setConnectedFieldDetails(prev => ({
            ...prev,
            [key]: value
        }));
    };
    const resetAuthDetails = () => {
        setAuthDetails({
            type: "",
            name: "",
            token: ""
        });
        setShowAuthModal(false);
    };

    const handleOpenConnectedFieldModal = () => {
        setShowConnectedFieldModal(true);
    };
    const resetConnectedFieldDetails = () => {
        setConnectedFieldDetails({
            name: "",
            type: "",
            predefinedValue: ""
        });
        setShowConnectedFieldModal(false);
    };

    const handleGetAuthorizationsData = () => {
        const companyID = localStorage.getItem("currentCompanyID");
        Library.makeApiRequest({
            data: { companyID, filters: { posIDs: [posID], environmentNames: [environmentName] } },
            endpoint: "getAuthorizationsData",
            setLoader: setAuthLoader
        })
            .then(res => {
                if (res?.data?.status === 200) {
                    const authorizations = res?.data?.data?.result?.[0]?.authorizations?.map(auth => auth?.name) || [];
                    setAuthOptions([...authorizations, "+ Create New"]);

                    const allAuth = res?.data?.data?.result?.flatMap(item => item?.authorizations || []) || [];

                    const authNameToUse = authorizationFieldsData?.authName || allAuth?.[0]?.name || "";

                    setAuthorizationFieldsData(prev => ({
                        ...prev,
                        authName: authNameToUse,
                        authData: allAuth
                    }));
                }
            })
            .catch(error => {
                console.error("Error fetching authorizations data:", error);
            });
    };

    const handleGetConnectedFieldsData = () => {
        Library.makeApiRequest({
            data: { posID: posID, environmentName: environmentName },
            endpoint: "getConnectFieldsData",
            setLoader: setLoading
        })
            .then(res => {
                if (res?.data?.status === 200) {
                    const allConnectFields =
                        res?.data?.data?.map(field => ({
                            name: field.name,
                            value: field.name,
                            isConnectField: true,
                            predefinedValue: field.predefinedValue || ""
                        })) || [];
                    setConnectedFieldOptions(allConnectFields);
                }
            })
            .catch(error => {
                console.error("Error fetching authorizations data:", error);
            });
    };
    const handleSaveApi = ({ filteredSteps }) => {
        Library.makeApiRequest({
            data: {
                posID,
                environmentName,
                apiName,
                stepsData: filteredSteps
            },
            endpoint: "saveAPI",
            setLoader: setLoading,
            method: "POST"
        }).then(res => {
            if (res?.data?.status === 200) {
                Library.showToastMessage({
                    type: "success",
                    title: "API steps updated successfully"
                });
                setShowTestConnection(prev => ({
                    ...prev,
                    showButton: true
                }));
            }
        });
    };
    const handleGetApi = () => {
        Library.makeApiRequest({
            data: { posID, environmentName, apiName },
            endpoint: "getAPI",
            setLoader: setLoading,
            method: "POST"
        }).then(res => {
            setConnectedFieldOptions(prev => [...prev]);
            if (res?.data?.status === 200) {
                const apiData = res?.data?.data;
                setApiStepsData(apiData || []);
            }
        });
    };

    const isAuthDetailsValid = () => {
        if (!authDetails?.type || !authDetails?.name || !isAuthFormValid) return false;
        if (authDetails.type === "Bearer Token" && !authDetails.token) return false;

        return true;
    };
    const isConnectedFieldDetailsValid = () => {
        if (!connectedFieldDetails.name || !connectedFieldDetails.type) return false;
        if (connectedFieldDetails.type === "BOtag" && !connectedFieldDetails.predefinedValue) return false;
        return true;
    };
    let registeredHandler = async () => {};

    const formValidHandler = isFormValid => {
        setIsAuthFormValid(isFormValid);
    };

    const handleTestAPIconnection = async () => {
        Library.makeApiRequest({
            endpoint: "testAPIconnection",
            data: {
                posID: posID,
                environmentNames: [environmentName],
                apiName,
                connectFields,
                extraFields
            },
            method: "POST",
            setLoader: setTestConnectionLoader
        }).then(res => {
            const isSuccess = res?.data?.data?.isPosResultSuccess;
            const data = JSON.stringify(res?.data?.data?.fullResponse, null, 2);
            setTestApiData(data || []);
            if (isSuccess) {
                Library.showToastMessage({
                    title: "Connection success!",
                    message: "All fields are correct and ready to go!"
                });
                setShowTestConnection(prev => ({
                    ...prev,
                    isSuccess: true
                }));
            } else {
                Library.showErrorMessage({
                    title: "Uh uh! something’s not right",
                    message: "Please make sure all fields are correct and test again."
                });
                setShowTestConnection(prev => ({
                    ...prev,
                    isSuccess: false
                }));
            }
        });
    };

    // #endregion

    // #region  EFFECTS
    useEffect(() => {
        setupHeaders(props);
    }, [props?.layoutType, JSON.stringify(filteredSteps), showTestConnection]);

    useEffect(() => {
        if (action === apiActions.EDIT && posID && environmentName) {
            handleGetApi();
        }
        handleGetAuthorizationsData();
        handleGetConnectedFieldsData();
        validate(apiName);
    }, [posID, environmentName, action]);

    // #endregion
    return (
        <>
            <FullScreenLoader isLoading={loading || authLoader}>
                {showApiPageSidePanel ? (
                    <ApiPageSidePanel
                        setShowApiPageSidePanel={setShowApiPageSidePanel}
                        selectedCategory={selectedCategory}
                    />
                ) : null}
                <FullScreenOverlay show={showSaveApiModal}>
                    <DialogBoxComponent
                        width="360px"
                        buttonWidth="135px"
                        confirmText="SAVE"
                        cancelText="CANCEL"
                        heading="Save Steps"
                        showCancel={true}
                        useAlternativeLayout={
                            <div className="m-16px">
                                <div className="text-center mt-2">
                                    <span className="text">Do you want to save the changes?</span>
                                </div>
                            </div>
                        }
                        onClickNo={() => {
                            setShowSaveApiModal(false);
                        }}
                        onClickYes={() => {
                            setShowSaveApiModal(false);
                            handleSaveApi({ filteredSteps });
                        }}
                    />
                </FullScreenOverlay>
                <FullScreenOverlay show={showAuthModal}>
                    <DialogBoxComponent
                        width={authDetails.type === authTypeEnums.NO_AUTH ? "1000px" : "360px"}
                        buttonWidth="135px"
                        confirmText="SAVE"
                        confirmState={isAuthDetailsValid() ? "secondary" : "disabled"}
                        heading="Create New Authorization"
                        showCancel={false}
                        onClickYes={() => {
                            setShowAuthModal(false);
                            registeredHandler();
                        }}
                        useAlternativeLayout={
                            <AuthorizationPopup
                                handleAuthChange={handleAuthChange}
                                authDetails={authDetails}
                                handleOpenConnectedFieldModal={handleOpenConnectedFieldModal}
                                connectedFieldOptions={connectedFieldOptions}
                                registerYesHandler={fn => {
                                    registeredHandler = fn;
                                }}
                                posID={posID}
                                environmentName={environmentName}
                                handleGetAuthorizationsData={handleGetAuthorizationsData}
                                resetAuthDetails={resetAuthDetails}
                                setLoading={setLoading}
                                formValidHandler={formValidHandler}
                            />
                        }
                        showCloseButton={true}
                        onClickCloseBtn={() => resetAuthDetails()}
                    />
                </FullScreenOverlay>
                <FullScreenLoader isLoading={connectedFieldLoader || loading}>
                    <FullScreenOverlay show={showConnectedFieldModal}>
                        <DialogBoxComponent
                            buttonWidth="135px"
                            confirmText="SAVE"
                            confirmState={isConnectedFieldDetailsValid() ? "secondary" : "disabled"}
                            heading="Create New Connect Field"
                            showCancel={false}
                            onClickYes={() => {
                                setShowConnectedFieldModal(false);
                                registeredHandler();
                            }}
                            useAlternativeLayout={
                                <ConnectedFieldPopup
                                    handleConnectedFieldChange={handleConnectedFieldChange}
                                    connectedFieldDetails={connectedFieldDetails}
                                    resetConnectedFieldDetails={resetConnectedFieldDetails}
                                    handleGetConnectedFieldsData={handleGetConnectedFieldsData}
                                    posID={posID}
                                    environmentName={environmentName}
                                    registerYesHandler={fn => {
                                        registeredHandler = fn;
                                    }}
                                    setConnectedFieldLoader={setConnectedFieldLoader}
                                />
                            }
                            showCloseButton={true}
                            onClickCloseBtn={() => resetConnectedFieldDetails()}
                        />
                    </FullScreenOverlay>
                </FullScreenLoader>
                <FullScreenOverlay show={showTestConnection.showPopup}>
                    <DialogBoxComponent
                        confirmState={isTestFormValid ? "secondary" : "disabled"}
                        confirmText={
                            testConnectionLoader ? (
                                <div className="flex align-item-center gap-6px">
                                    <img
                                        src={Loader}
                                        alt=""
                                        className="loader"
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                            animation: "spin 1s linear infinite"
                                        }}
                                    />
                                    <div style={{ color: "rgba(255, 255, 0, 1)" }}> TESTING CONNECTION...</div>
                                </div>
                            ) : (
                                <div>
                                    {showTestConnection?.isSuccess
                                        ? "CLOSE"
                                        : showTestConnection?.isSuccess === false
                                        ? "TEST AGAIN"
                                        : "TEST"}
                                </div>
                            )
                        }
                        width="1000px"
                        heading={
                            showTestConnection.isSuccess
                                ? "SUCCESS!"
                                : showTestConnection.isSuccess === false
                                ? "FAILED"
                                : "Test Connection"
                        }
                        buttonWidth={"200px"}
                        headingColor={
                            showTestConnection.isSuccess === false ? "rgba(255, 54, 54, 1)" : "rgba(0, 187, 0, 1)"
                        }
                        title={
                            showTestConnection.isSuccess
                                ? "CONNECTION SUCCESS!"
                                : showTestConnection.isSuccess === false
                                ? "Connection Failed"
                                : ""
                        }
                        showCloseButton={true}
                        onClickCloseBtn={() => {
                            if (!testConnectionLoader) {
                                resetStepsFieldValues();
                                setShowTestConnection(prev => ({
                                    ...prev,
                                    showPopup: false,
                                    isSuccess: undefined
                                }));
                                setTestApiData([]);
                            }
                        }}
                        onClickYes={() => {
                            if (!testConnectionLoader) {
                                if (showTestConnection?.isSuccess) {
                                    setShowTestConnection(prev => ({
                                        ...prev,
                                        showPopup: false,
                                        isSuccess: undefined
                                    }));
                                    setTestApiData([]);
                                } else {
                                    handleTestAPIconnection();
                                }
                            }
                        }}
                        showCancel={false}
                        useAlternativeLayout={
                            <TestConnectionPopup
                                getFieldsByCategory={getFieldsByCategory}
                                handleOpenConnectedFieldModal={handleOpenConnectedFieldModal}
                                updatePopField={updatePopField}
                                isSuccess={showTestConnection.isSuccess}
                                testConnectionLoader={testConnectionLoader}
                                stepsWithAuth={stepsWithAuth}
                                dropDownData={popupDropDown}
                                testApiData={testApiData}
                            />
                        }
                    />
                </FullScreenOverlay>

                <div className="p-6 bg-gray-950 min-h-screen text-white">
                    <FormCard
                        title="API ID"
                        ref={formProductIDs}
                        numOfFieldsPerLine={4}
                        showDefaultRightLegends={true}
                        formFields={productFormFields}
                        formFieldRefs={formFieldRefs}
                        onFormChanged={() => {}}
                    />
                    <FormContainer showDefaultRightLegends={true} title="STEPS">
                        <StepFormStyle>
                            <div className="input-field-card-layout-1">
                                {steps?.map((step, index) => (
                                    <StepForm
                                        key={index}
                                        step={step}
                                        stepIndex={index}
                                        addField={addField}
                                        updateField={updateField}
                                        getFieldsByCategory={getFieldsByCategory}
                                        removeField={removeField}
                                        removeStep={removeStep}
                                        updateStepField={updateStepField}
                                        onAddStepClick={addStep}
                                        handleOpenAuthModal={() => setShowAuthModal(true)}
                                        authOptions={authOptions}
                                        handleOpenConnectedFieldModal={handleOpenConnectedFieldModal}
                                        connectedFieldOptions={connectedFieldOptions}
                                        setShowApiPageSidePanel={setShowApiPageSidePanel}
                                        inputFields={inputFields}
                                        outputFields={outputFields}
                                        setSelectedCategory={setSelectedCategory}
                                        setAuthorizationFieldsData={setAuthorizationFieldsData}
                                        updateArraySubField={updateArraySubField}
                                        removeArraySubField={removeArraySubField}
                                    />
                                ))}
                                <div className="frame-295922379" onClick={addStep}>
                                    <div className="btn-sm-special2">
                                        <img className="plus5" src={Plus} alt="" />
                                        <div className="step">STEP</div>
                                    </div>
                                </div>
                            </div>
                        </StepFormStyle>
                    </FormContainer>
                </div>
            </FullScreenLoader>
        </>
    );
};

export default ApiPage;

// #region SMALL COMPONENTS

const setupHeaders = props => {
    props.setControlBarCenterBtns([{ to: "/products", active: true, disabled: false, title: "PRODUCTS" }]);

    props.setControlBarRightBtns([
        { to: "#", active: false, disabled: true, title: "View", icon: "eye" },
        { to: "#", active: true, disabled: false, title: "Add", icon: "plus" },
        { to: "#", active: false, disabled: true, title: "Details", icon: "microscope" },
        { to: "#", active: false, disabled: true, title: "Edit", icon: "edit" }
    ]);

    props.setFilterHeaderProperties({
        customContentHeader: (
            <>
                <SimpleButtonContentHeader
                    btnTitle="SAVE"
                    btnEnabled={props?.isFormValid}
                    onClick={props?.onSaveButtonClick}
                    secondBtnTitle="TEST CONNECTION"
                    secondBtnEnabled={props?.action === apiActions.EDIT || props?.secondBtnEnabled}
                    onSecondBtnClick={props?.onSecondBtnClick}
                />
            </>
        )
    });
};
// #endregion
